import { DetailedReactHTMLElement } from 'react';

export const isReactComponent = (value: any): value is DetailedReactHTMLElement<any, any> => {
  return (
    value
    && typeof value === 'object'
    || typeof value === 'function'
  );
};
